import { Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { BackButtonHandler } from './components/BackButtonHandler'
import { Cart } from './pages/Cart'
import { Catalog } from './pages/Catalog'
import { Checkout } from './pages/Checkout'
import { OrderDetail } from './pages/OrderDetail'
import { Orders } from './pages/Orders'
import { ProductDetail } from './pages/ProductDetail'
import { SignIn } from './pages/SignIn'

export function App() {
  return (
    <>
      <BackButtonHandler />
      <Routes>
        <Route element={<Layout />}>
        <Route index element={<Catalog />} />
        <Route path="c/:categorySlug" element={<Catalog />} />
        <Route path="p/:slug" element={<ProductDetail />} />
        <Route path="cart" element={<Cart />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="orders" element={<Orders />} />
        <Route path="orders/:orderId" element={<OrderDetail />} />
        <Route path="sign-in" element={<SignIn />} />
        <Route path="*" element={<Catalog />} />
      </Route>
    </Routes>
    </>
  )
}
